import { v4 as uuid } from "uuid";

import { getRandomDigitString } from "./FormBuilderQuestion";

// interface IQuestionRow {
//   id: string | number;
//   order: number;
//   question: number;
//   text?: ?string;
//   help_text?: ?string;
//   is_required?: ?boolean;
//   form_index: number;
// }

// Values example:
// help_text: ""
// id: 15
// is_required: false
// order: 0
// question: 261
// text: "Question 1"

class QuestionRow {
  constructor(
    { id, order, question, text, help_text, is_required, form_index },
    isNew = true,
  ) {
    this.id = id || uuid();
    this.order = order || 0;
    this.question = question;
    this.text = text;
    this.help_text = help_text;
    this.is_required = is_required;
    this.isNew = isNew;
    this.form_index = Number(form_index || getRandomDigitString());
  }
}

export default QuestionRow;
